<template>
    <article class="post-teaser" :class="post.type">
        
        <div class="content">
            <p class="post-date">{{post.date}}</p>
            <p class="post-title"><a :href="post.link">{{post.title.rendered}}</a></p>
            <p class="post-desc" v-html="post.excerpt.rendered"></p>
            <a :href="post.link" class="button align-self-bottom">Læs mere</a>
        </div>
        
    </article>
</template>

<script>
    export default {
        mounted() {
            console.log(this.post);
    	},
        props: ['post']
    }
</script>